import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { customerValuesType } from '../../types'

export interface ProductDetailState {
  'p-intro': customerValuesType.Intro
  'p-customer': customerValuesType.Customer
  'p-generator': customerValuesType.Generator
  'p-overview': customerValuesType.Overview
  'p-vendor': customerValuesType.Vendor
  stromlieferantName: customerValuesType.StromlieferantName
}

const initialState: ProductDetailState = {
  'p-intro': {
    'pv-system': '1',
    'power-consumption-year-kwh': '',
    'grid-feed-year-kwh': '',
    'pv-nominal-power-kwp': '',
    'senec-system-id': 1,
    'pv-specific-yield-year-kwh-kwp': 950,
    'customer-postleitzahl': '',
    'intro-ctg-paketCloudToGo': false,
    'intro-ctg-annual-mileage': '',
    'intro-ctg-car-consumption': '',
    'intro-ctg-at-home': '',
    'intro-wae-waermePaket': false,
    'generator-anlage-inbetriebnahme': '',
    'intro-faf-paketFamilyAndFriends': false,
    'intro-faf-1-details': true,
    'intro-faf-1-postleitzahl': '',
    'intro-faf-2-details': false,
    'intro-faf-2-postleitzahl': '',
    'intro-wae-vorjahresstromverbrauch': '',
    'intro-wae-heat-pump': '1',
    'intro-faf-1-vorjahresstromverbrauch': '',
    'intro-faf-2-vorjahresstromverbrauch': ''
  },
  'p-customer': {
    'customer-type': '0',
    'customer-anrede': '',
    'customer-firmenname': '',
    'customer-titel': '',
    'customer-vorname': '',
    'customer-nachname': '',
    'customer-strasse': '',
    'customer-hausnummer': '',
    'customer-postleitzahl': '',
    'customer-ort': '',
    'customer-geburtstag': '',
    'customer-telefonnummer': '',
    'customer-emailAddresse': '',
    'customer-email-confirmation': '',
    'customer-rechnungsadresse-abweichend': false,
    'customer-strasse-abw': '',
    'customer-strasse-abw-alt': '',
    'customer-hausnummer-abw': '',
    'customer-postleitzahl-abw': '',
    'customer-ort-abw': '',
    'customer-ort-abw-alt': '',
    'customer-zahlungsweise': 'customer-zahlungsweise-lastschrift',
    'customer-bankverbindung-vorname': '',
    'customer-bankverbindung-nachname': '',
    'customer-bankverbindung-iban': '',
    'customer-iban-mandatory': false,
    'customer-bankverbindung-bic': '',
    'customer-bankverbindung-geldinstitut': ''
  },
  'p-generator': {
    'pv-address': '1',
    'generator-anlageschluessel': '',
    'generator-contract-number': '',
    'generator-anlage-zaehlernummer': '',
    'generator-anlage-inbetriebnahme': '',
    'generator-anlage-leistung': '',
    'generator-marktlokations-id': '',
    'generator-weitere-anlagenbetreiber-name': '',
    'generator-weitere-anlagenbetreiber-vorname': '',
    'generator-email': '',
    'generator-weitere-anlagenbetreiber-name2': '',
    'generator-weitere-anlagenbetreiber-vorname2': '',
    'generator-email2': '',
    'generator-extra-operator': false,
    'generator-anlagenstandort-strasse': '',
    'generator-anlagenstandort-strasse-alt': '',
    'generator-anlagenstandort-hausnummer': '',
    'generator-anlagenstandort-postleitzahl': '',
    'generator-anlagenstandort-ort': '',
    'generator-anlagenstandort-ort-alt': '',
    'generator-steuerAbfuehren': false,
    'generator-erzeugungszaehler': false,
    'generator-zusaetzliche-einspeisezaehler': false,
    'generator-erzeugungszaehler-zaehlernummer': '',
    'generator-einspeisezaehler-zaehlernummer': ''
  },
  'p-overview': {
    'overview-aktionscode': '',
    'overview-agb': false,
    'overview-vertrag-kuendigen': false,
    'overview-bestens-informiert': false,
    'overview-kenntnis-genommen': false,
    'code-amount': 0
  },
  'p-vendor': {
    'vendor-waerme-anbieter': null,
    'vendor-waerme-zaehlernummer': '',
    'marktlokations-identifikationsnummer': '',
    'vendor-waerme-vorjahresstromverbrauch': '',
    'vendor-waerme-kuendigungSonder': false,
    'vendor-waerme-kuendigungSonder-vertragspartner': '',
    'vendor-waerme-kuendigungSonderDatum': '',
    'vendor-waerme-wechselgrund': 'vendor-waerme-lieferantwechsel',
    'vendor-waerme-neuEingezogenDatum': null,
    'vendor-wae-vorjahresstromverbrauch': '',
    'vendor-wae-anbieter': null,
    'vendor-wae-zaehlernummer': '',
    'vendor-wae-marktlokations-id': '',
    'vendor-wae-kuendigungSonder': false,
    'vendor-wae-kuendigungSonder-vertragspartner': '',
    'vendor-wae-kuendigungSonderDatum': '',
    'vendor-wae-wechselgrund': 'vendor-wae-lieferantwechsel',
    'vendor-wae-neuEingezogenDatum': null,
    'vendor-faf-1-vorjahresstromverbrauch': '',
    'vendor-faf-1-strasse': '',
    'vendor-faf-1-strasse-alt': '',
    'vendor-faf-1-hausnummer': '',
    'vendor-faf-1-postleitzahl': '',
    'vendor-faf-1-ort': '',
    'vendor-faf-1-ort-alt': '',
    'vendor-faf-1-anbieter': null,
    'vendor-faf-1-vorname': '',
    'vendor-faf-1-name': '',
    'vendor-faf-1-zaehlernummer': '',
    'vendor-faf-1-kuendigungSonder': false,
    'vendor-faf-1-marktlokations-id': '',
    'vendor-faf-1-kuendigungSonder-vertragspartner': '',
    'vendor-faf-1-kuendigungSonderDatum': '',
    'vendor-faf-1-wechselgrund': 'vendor-faf-1-lieferantwechsel',
    'vendor-faf-1-neuEingezogenDatum': null,
    'vendor-faf-2-vorjahresstromverbrauch': '',
    'vendor-faf-2-strasse': '',
    'vendor-faf-2-strasse-alt': '',
    'vendor-faf-2-hausnummer': '',
    'vendor-faf-2-postleitzahl': '',
    'vendor-faf-2-ort': '',
    'vendor-faf-2-ort-alt': '',
    'vendor-faf-2-anbieter': null,
    'vendor-faf-2-vorname': '',
    'vendor-faf-2-name': '',
    'vendor-faf-2-zaehlernummer': '',
    'vendor-faf-2-kuendigungSonder': false,
    'vendor-faf-2-marktlokations-id': '',
    'vendor-faf-2-kuendigungSonder-vertragspartner': '',
    'vendor-faf-2-kuendigungSonderDatum': '',
    'vendor-faf-2-wechselgrund': 'vendor-faf-2-lieferantwechsel',
    'vendor-faf-2-neuEingezogenDatum': null
  },
  stromlieferantName: {
    lichtstrom: '',
    waermestrom: '',
    familyAndFriends: '',
    familyAndFriends2: ''
  }
}

export const customerInputValuesSlice = createSlice({
  name: 'customervalues',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setCustomerValuesIntroSlice: (
      state,
      action: PayloadAction<customerValuesType.Intro>
    ) => {
      state['p-intro'] = action.payload
    },
    setCustomerValuesCustomerSlice: (
      state,
      action: PayloadAction<customerValuesType.Customer>
    ) => {
      state['p-customer'] = action.payload
    },
    setCustomerValuesGeneratorSlice: (
      state,
      action: PayloadAction<customerValuesType.Generator>
    ) => {
      state['p-generator'] = action.payload
    },
    setCustomerValuesOverviewSlice: (
      state,
      action: PayloadAction<customerValuesType.Overview>
    ) => {
      state['p-overview'] = action.payload
    },
    setCustomerValuesVendorSlice: (
      state,
      action: PayloadAction<customerValuesType.Vendor>
    ) => {
      state['p-vendor'] = action.payload
    },
    setCustomerValuesStromlieferantNameSlice: (
      state,
      action: PayloadAction<customerValuesType.StromlieferantName>
    ) => {
      state.stromlieferantName = action.payload
    }
  }
})

export const {
  setCustomerValuesIntroSlice,
  setCustomerValuesCustomerSlice,
  setCustomerValuesGeneratorSlice,
  setCustomerValuesOverviewSlice,
  setCustomerValuesVendorSlice,
  setCustomerValuesStromlieferantNameSlice
} = customerInputValuesSlice.actions

export default customerInputValuesSlice.reducer
